<template>
    <div class="view-count text-uppercase">
        <span class="eye shaped"></span>
        <span>
            {{viewerCount}} <span class="live-text">live</span>
        </span>
    </div>
</template>
<script>
export default {
  props: [],
  data: function () {
    return {
      timerInterval: '',
      viewerCount: 0
    }
  },
  mounted () {
    this.viewerCount = this.generateRandomNumber(500, 1000)
    this.timerInterval = setInterval(() => {
      this.viewerCount = this.generateRandomNumber(500, 1000)
    }, 5000)
  },
  beforeDestroy () {
    clearInterval(this.timerInterval)
  },
  methods: {
    generateRandomNumber: function (min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min)
    }
  }
}
</script>
<style scoped>
  @keyframes blinker {
    0% {
      opacity: 1;
    }
    25% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    75% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .view-count {
    display: flex;
    align-items: center;
    color: #777;
  }

  .live-text {
    text-decoration: blink;
    color: #f00;
    animation-name: blinker;
    animation-duration: 2.5s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    animation-direction: alternate;
  }

  .eye {
    position: relative;
    display: inline-block;
    width: 25px;
    height: 25px;
    color: transparent;
    margin-right: 5px;
  }

  .eye:before,
  .eye:after {
    position: absolute;
    content:'';
    display: block;
    top: 50%;
    left: 50%;
    opacity: 0;
  }

  .eye:before {
    top: 10%;
    left: 10%;
    background-color: #777;
    width: 80%;
    height: 80%;
  }

  .eye:after {
    border: 2px solid;
    border-color: #fff;
    width: 40%;
    height: 40%;
    margin-left: -20%;
    margin-top: -20%;
  }

  .eye.shaped:after {
    border-radius: 100%;
    opacity:1;
  }

  .eye.shaped:before {
    border-radius: 0 80% 0 80%;
    transform: rotate(-45deg);
    opacity: 1;
  }

  @media screen and (max-width: 480px) {
    .eye {
      width: 20px;
      height: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// Viewers.vue?638dfda8